export enum DiscountType {
    Percentage,
    Currency,
}

export interface IClient {
    id: number;
    name: string;
    discount: number;
    discountType: DiscountType;
}
